function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "add");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "6_Statistik",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "3_Statistik_ABC-Statistik",
  transform: "translate(-567.000000, -248.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Auswahl-Copy-4",
  transform: "translate(347.000000, 239.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "add",
  transform: "translate(220.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  stroke: "#2F3648",
  strokeWidth: 0.5,
  fillOpacity: 0.1,
  fill: "#FFFFFF",
  cx: 9,
  cy: 9,
  r: 8.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,4 C9.27614237,4 9.5,4.22385763 9.5,4.5 L9.5,8.499 L13.5,8.5 C13.7761424,8.5 14,8.72385763 14,9 C14,9.27614237 13.7761424,9.5 13.5,9.5 L9.5,9.499 L9.5,13.5 C9.5,13.7761424 9.27614237,14 9,14 C8.72385763,14 8.5,13.7761424 8.5,13.5 L8.5,9.5 L4.5,9.5 C4.22385763,9.5 4,9.27614237 4,9 C4,8.72385763 4.22385763,8.5 4.5,8.5 L8.5,8.5 L8.5,4.5 C8.5,4.22385763 8.72385763,4 9,4 Z",
  id: "Combined-Shape",
  fill: "#FFD91F"
})))));

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.09043939.svg";
export { ForwardRef as ReactComponent };